<div class="qty-container">
  <span class="qty-minus" (click)="minus()">
    <fa-icon [icon]="faMinusCircle" size="lg"></fa-icon>
  </span>

  <span class="qty-number">{{ quantity }}</span>

  <span class="qty-plus" (click)="plus()">
    <fa-icon [icon]="faPlusCircle" size="lg"></fa-icon>
  </span>
</div>